import { create } from 'zustand'
import type { Socket } from 'socket.io-client'

interface GameState {
  socket: Socket | undefined
  setSocket: (value: Socket | undefined) => void
}

const useGameStore = create<GameState>()(set => ({
  socket: undefined,
  setSocket: value => {
    set({ socket: value })
  }
}))

export default useGameStore
